import React, { useState } from 'react'

import lang from '@/lang'

import CustomerService from '../../customerService'
import CustomerAddressFormModal from '../edit/address/form-modal/address-form-modal'
import SelectInput from '../../../base/components/inputs/select-input/select-input'
import { checkModuleAccess } from '@/modules'
import { SUBSCRIPTION_MODULES } from '@/modules/base/util/constants'

async function fetchCustomer(searchTerm, loadedOptions) {
  try {
    const offset = loadedOptions?.length || 0
    const { data: customers, meta: { count } } = await CustomerService.find(searchTerm, offset, 10)

    const selectOptions = customers.map(customer => {
      const { id, name, number } = customer
      return {
        value: id,
        label: `${number} - ${name}`,
        customer,
      }
    })

    const hasMore = (offset + selectOptions.length) !== count

    return {
      options: selectOptions,
      hasMore,
    }
  } catch (error) {
    console.error(error)
  }
}

export function CustomerSelect(props) {
  const { onAdd, onChange, customModal, customOpen, isMulti, ...restProps } = props
  const [open, setOpen] = useState(false)
  const [newCustomer, setNewCustomer] = useState()

  const allowCreate = Boolean(onAdd)

  const options = {
    infiniteScroll: true,
    allowCreate,
    customSelectOptions: {
      isClearable: props.clearable || false,
      escapeClearsValue: true,
      hideSelectedOptions: false,
      placeholder: lang.selectInput.customer.placeholder(allowCreate),
      defaultMenuIsOpen: false,
      defaultOptions: true,
      loadOptions: fetchCustomer,
      loadingMessage: lang.selectInput.customer.loadingMessage,
      isMulti,
    },
    useFormik: false,
  }

  const defaultCustomerObject = {
    kind: 'company',
    companyName: newCustomer,
    isDefaultBilling: true,
    isBillingDisabled: true,
    isDefaultDelivery: true,
    isDeliveryDisabled: true,
  }

  const handleCustomerAdd = (name) => {
    if (customOpen) {
      customOpen({ ...defaultCustomerObject, companyName: name })
    } else {
      setNewCustomer(name)
      setOpen(true)
    }
  }
  const handleAddressSubmit = (addresses) => {
    setOpen(false)
    onAdd && onAdd(addresses)
  }

  const handleCustomerChange = (option) => {
    onChange && onChange(option)
  }

  const handleAbort = () => {
    setOpen(false)
  }

  const addressFormModal = open
    ? (
      <CustomerAddressFormModal
        address={defaultCustomerObject}
        onFinish={handleAddressSubmit}
        onAbort={handleAbort} />
    )
    : null

  return checkModuleAccess(SUBSCRIPTION_MODULES.CUSTOMERS)
    ? (
      <>
        <SelectInput
          {...restProps}
          {...options}
          onOptionCreated={handleCustomerAdd}
          handleChange={handleCustomerChange} />
        {props.customModal || addressFormModal}
      </>
    )
    : null
}
